// extracted by mini-css-extract-plugin
export default {"root":"VerificationSmsSetupView_root__+qnjY","formWrapper":"VerificationSmsSetupView_formWrapper__LWcED","phone":"VerificationSmsSetupView_phone__18d8F"};